// extracted by mini-css-extract-plugin
export default {"employee-container":"LoanRequest_employee-container__dgEs1","loan-header":"LoanRequest_loan-header__JRkJG","loan-header__buttons":"LoanRequest_loan-header__buttons__HX4EV"};